const GATE_ACCESS_PATH_RE =
  /^\/gate-access\/([0-9a-fA-F-]{8}-[0-9a-fA-F-]{4}-[0-9a-fA-F-]{4}-[0-9a-fA-F-]{4}-[0-9a-fA-F-]{12}|[0-9a-zA-Z-]+)$/;

export function matchGateAccessPath(pathname: string): string | null {
  const match = pathname.match(GATE_ACCESS_PATH_RE);
  return match?.[1] ?? null;
}

export function gateAccessPath(uuid: string): string {
  return `/gate-access/${uuid}`;
}

export function isGateAccessLandingPage(landingPage: string | null | undefined): boolean {
  if (!landingPage) return false;
  const pathname = landingPage.split('?')[0] ?? '';
  return matchGateAccessPath(pathname) !== null;
}
